import React, { useMemo } from 'react';
import render from 'react-render-html';
import { VStack, View } from '~/native-ui/native-base';
import { List } from '~/native-ui/List';
import { Link } from '~/native-ui/Link';
import { Icon } from '~/native-ui/Icon';
import { Text, Small, Strong } from '~/native-ui/Typography';
import { Tooltip } from 'native-base';
import get from 'lodash/get';

const MemoizedSpan = React.memo(({ title, ...prop }) => {
    return title ? (
        <Tooltip label={title} hasArrow>
            <MemoizedText maxWidth="100%" width="max-content" {...prop} lineHeight="inherit" fontFamily="inherit" />
        </Tooltip>
    ) : (
        <MemoizedText {...prop} lineHeight="inherit" fontFamily="inherit" maxWidth="100%" />
    );
});

const MemoizedText = React.memo(
    React.forwardRef(({ value, ...props }, ref) => {
        return (
            <Text fontSize="inherit" lineHeight="inherit" fontWeight="inherit" {...props} ref={ref}>
                {value}
                {props.children}
            </Text>
        );
    })
);

const UnstyledList = React.memo((props) => {
    return (
        <List ul={false} ol={false} {...props}>
            {React.Children.map(props.children, (child, i) => (
                <React.Fragment key={i}>{React.cloneElement(child, { pl: '0', unstyled: true })}</React.Fragment>
            ))}
        </List>
    );
});

const StyledLink = React.memo(({ title, ...props }) => {
    return <Link {...props} color="inherit" />;
});


const Paragraph = React.memo(({ children, ...props }) => {
    const webStyles = useMemo(() => {
        return [props._web?.style, { display: 'block', margin: 0 }];
    }, [props._web?.stye]);

    return (
        <View {...props} _web={{ ...props._web, style: webStyles }}>{children}</View>
    );
});

const customComponents = {
    Text: MemoizedText,
    a: StyledLink,
    ul: UnstyledList,
    ol: List.Ordered,
    li: List.Item,
    span: MemoizedSpan,
    small: Small,
    strong: Strong,
    div: VStack,
    p: Paragraph,
    br: () => null,
    icon: React.memo((props) => {
        const { icon, "icon-family": iconFamily, ...rest } = props;
        return <Icon {...rest}  color="inherit" iconFamily={iconFamily} value={icon} lineHeight="1" />
    }),
};

export const renderHTML = (html, components = {}) => {
    const emailRegex = /\<\S+@\S+\.\w+\>/g;
    if (html && emailRegex.test(html)) {
        html = html
            .replace(
                /\<\S+@\S+\.\w+\>/g,
                (match) => match.replace('<', '&lt;').replace('>', '&gt;')
            );
    }
    
    return render(html, { ...customComponents, ...components });
};

export const overrideDefaultComponents = (components = {}) => {
    Object.assign(customComponents, components);
}


export const getDefaultComponent = (key) => {
    return customComponents[key];
}